import RegistryAvatar from './registry-avatar'

export default RegistryAvatar
